import {useEffect} from 'react';
import Styles from 'src/components/Styles';
import {
  Dimensions,
  FlatList,
  Modal,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';

import {UserRewardsTierIcon} from 'src/components/img/svg/rewards';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import PayEarnPoints from 'src/components/img/svg/rewards/PayEarnPoints';
import PayEarnedStatus from 'src/components/img/svg/rewards/PayEarnedStatus';
import PayPointsExpiration from 'src/components/img/svg/rewards/PayPointsExpiration';
import {getDescriber as getAccountDescriber} from 'src/components/screens/account/descriptor/DescriptorType';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {getArticle} from 'src/Util';
import RewardDetailsInfo from './RewardsDetailsInfo';

const screenWidth = Dimensions.get('window').width;
const multipler = Platform.OS === 'web' ? 0.45 : 0.9;
const modalWidth = screenWidth * multipler;
const {height: screenHeight} = Dimensions.get('window');
interface RewardDetailsProps {
  hideModal?: () => void;
  statusTierDetailsdesc: {
    [index: string]: string;
  };
  statusTiers?: Array<{
    name: string;
    rewardStatusId: string;
    rewardProgramId: string;
    pointsThreshold: number;
    pointsRate: number;
    tierLevel: number;
    isDisabled: boolean;
    dateCreated: string;
    lastUpdated: string;
  }>;
}
const RewardDetails = (props: RewardDetailsProps) => {
  const {hideModal, statusTiers, statusTierDetailsdesc} = props;
  useEffect(() => {
    FirebaseAnalytic.trackEvent('componentDidMount', 'RewardDetails');
  }, []);

  //back to my rewards action
  const handleClick = () => {
    FirebaseAnalytic.trackEvent('onbackToRewardsClick', 'RewardDetails');
    hideModal();
    //NavActions.navigate(AppRoutes.SendSnack);
  };

  const handleClose = () => {
    hideModal();
  };
  const renderRewardDetailStatusItem = ({item}) => (
    <View style={styles.listItem}>
      {/* Icon */}
      <View style={styles.marginBottom}>
        <UserRewardsTierIcon tierName={item.name} size={100} />
      </View>
      {/* Title */}

      <AVText
        style={[
          styles.tierName,
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        aria-label={`${item.name} text`}
        accessibilityLabel={item.name}
      >
        {item.name}
      </AVText>

      <AVText
        style={[
          styles.pointNeeded,
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        aria-label={
          item.name === 'Member'
            ? Localized.Labels.member_subtitle
            : `${item.pointsThreshold} points needed`
        }
        role="status"
        accessibilityLabel={
          item.name === 'Member'
            ? Localized.Labels.member_subtitle
            : `${item.pointsThreshold} points needed`
        }
      >
        {item.name === 'Member'
          ? Localized.Labels.member_subtitle
          : `${item.pointsThreshold} points needed`}
      </AVText>

      <AVText
        style={[
          styles.pointRate,
          {color: getButtonDescriber().checkRoundedBtnColor()},
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        aria-label={`$1 = ${item.pointsRate} points`}
        accessibilityLabel={`$1 = ${item.pointsRate} points`}
      >
        {`$1 = ${item.pointsRate} points`}
      </AVText>

      <AVText
        style={[
          styles.pointDesc,
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        aria-label={`${Localized.Labels.formatString(
          statusTierDetailsdesc[item.tierLevel],
          item.pointsRate,
          item.name,
          getArticle(item.name),
        )} text`}
        accessibilityLabel={Localized.Labels.one_time_rewards_title}
      >
        {Localized.Labels.formatString(
          statusTierDetailsdesc[item.tierLevel],
          item.pointsRate,
          item.name,
          getArticle(item.name),
        )}
      </AVText>
    </View>
  );
  return (
    <Modal visible={true} onDismiss={handleClose} transparent={true}>
      <View style={styles.oneTimeRewardModalMain}>
        <View
          style={[
            styles.oneTimeRewardModalContainer,
            {height: screenHeight * 0.85},
          ]}
        >
          <AVTouchableOpacity
            aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
            role="button"
            style={styles.closeModalTitleContainer}
            onPress={handleClose}
            accessible
            accessibilityLabel={Localized.Buttons.cancel}
            accessibilityRole="button"
            testID="Close"
            hitSlop={Styles.HitSlop_10}
          >
            <CancelIcon />
          </AVTouchableOpacity>
          <ScrollView contentContainerStyle={styles.scrollView}>
            <View style={styles.oneTimeRewardModalContentContainer}>
              <AVText
                style={[
                  styles.rewardDetails,
                  getSnackDescriber()?.snackDetailsBtnFontSTyle(),
                ]}
                accessibilityLabel={Localized.Labels.reward_detail}
                aria-label={`${Localized.Labels.reward_detail} text`}
              >
                {Localized.Labels.reward_detail}
              </AVText>
              <AVText
                style={[
                  styles.rewardDetailsDesc,
                  getSnackDescriber()?.snackDetailsBtnFontSTyle(),
                ]}
                aria-label={`${Localized.Labels.reward_detail_desc} text`}
                accessibilityLabel={Localized.Labels.reward_detail_desc}
              >
                {Localized.Labels.reward_detail_desc}
              </AVText>

              {Platform.OS === 'web' ? (
                <View style={styles.webStaticBlockGrid}>
                  <View style={styles.row}>
                    <RewardDetailsInfo
                      IconComponent={PayEarnPoints}
                      title={Localized.Labels.reward_detail_earned_points}
                      description={
                        Localized.Labels.reward_detail_earned_points_desc
                      }
                    />
                    <RewardDetailsInfo
                      IconComponent={PayEarnedStatus}
                      title={Localized.Labels.reward_detail_earned_status}
                      description={
                        Localized.Labels.reward_detail_earned_status_desc
                      }
                    />
                  </View>
                  <View style={styles.row}>
                    <RewardDetailsInfo
                      IconComponent={PayPointsExpiration}
                      title={Localized.Labels.reward_point_expiration}
                      description={
                        Localized.Labels.reward_point_expiration_desc
                      }
                    />
                  </View>
                </View>
              ) : (
                <View style={styles.mobileStaticBlockStack}>
                  <RewardDetailsInfo
                    IconComponent={PayEarnPoints}
                    title={Localized.Labels.reward_detail_earned_points}
                    description={
                      Localized.Labels.reward_detail_earned_points_desc
                    }
                  />
                  <RewardDetailsInfo
                    IconComponent={PayEarnedStatus}
                    title={Localized.Labels.reward_detail_earned_status}
                    description={
                      Localized.Labels.reward_detail_earned_status_desc
                    }
                  />
                  <RewardDetailsInfo
                    IconComponent={PayPointsExpiration}
                    title={Localized.Labels.reward_point_expiration}
                    description={Localized.Labels.reward_point_expiration_desc}
                  />
                </View>
              )}
              <View style={styles.line} />
              <AVText
                style={[
                  styles.rewardStatus,
                  getSnackDescriber()?.snackDetailsBtnFontSTyle(),
                ]}
                aria-label={`${Localized.Labels.reward_statues} text`}
                accessibilityLabel={Localized.Labels.reward_statues}
              >
                {Localized.Labels.reward_statues}
              </AVText>
              <AVText
                style={[
                  styles.rewardStatuLvl,
                  getSnackDescriber()?.snackDetailsBtnFontSTyle(),
                ]}
                accessibilityLabel={Localized.Labels.reward_status_levels}
                aria-label={`${Localized.Labels.reward_status_levels} text`}
              >
                {Localized.Labels.reward_status_levels}
              </AVText>

              <FlatList
                data={statusTiers} // The array of objects
                keyExtractor={(item, index) => index + item.name} // Unique key for each item
                renderItem={renderRewardDetailStatusItem} // Render function
                style={{paddingVertical: 10}}
                numColumns={Platform.OS === 'web' ? 2 : 1}
              />
              <View style={styles.backToRewardsBtn}>
                <RoundedAppButton
                  buttonType={RoundedAppButtonType.Solid}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  accessibilityLabelValue={Localized.Buttons.back_to_rewards}
                  aria-label={Localized.Buttons.back_to_rewards}
                  onPress={handleClick}
                  buttonViewStyle={{paddingHorizontal: 24}}
                  buttonContainerStyle={[
                    getAccountDescriber()?.getStyleDescriptor().buttonSpacing,
                  ]}
                  textStyle={[Styles.Style.actionButtonText]}
                  titleText={Localized.Buttons.back_to_rewards}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};
const lineHeightMultiplier = 1.14;
const styles = StyleSheet.create({
  oneTimeRewardModalMain: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  oneTimeRewardModalContainer: {
    width: modalWidth,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingLeft: 28, // Padding inside the container
    paddingRight: 13,
    paddingBottom: 24, // Padding inside the container
    paddingTop: 38,
  },
  oneTimeRewardModalContentContainer: {
    paddingTop: 10,
  },
  closeModalTitleContainer: {
    position: 'absolute',
    zIndex: 999999,
    top: 5,
    right: 5,
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 24,
  },
  tierName: {
    fontSize: Styles.Fonts.f1 + 2,
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 + 2) * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m1,
  },
  pointNeeded: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m1 + 2,
    color: '#707070',
  },
  pointRate: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m1 + 2,
  },
  pointDesc: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m1,
    textAlign: 'center',
  },
  rewardDetails: {
    fontSize: Styles.Fonts.f1 + 6,
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 + 6) * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m1 + 2,
  },
  rewardDetailsDesc: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
  },
  earnedPointsRate: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
    paddingBottom: Styles.Spacing.m1 + 2,
  },
  rewardStatus: {
    fontSize: Styles.Fonts.f1 + 6,
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 + 6) * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m3 - 2,
  },
  rewardStatuLvl: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    lineHeight: Styles.Fonts.f1 * lineHeightMultiplier,
    marginBottom: Styles.Spacing.m3,
  },
  line: {
    height: 1,
    width: '100%',
    backgroundColor: '#CFCFCF',
    marginVertical: Styles.Spacing.m3,
    alignContent: 'center',
    alignSelf: 'center',
  },
  webStaticBlockGrid: {
    paddingTop: Styles.Spacing.m3,
    gap: Styles.Spacing.m3,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m2,
  },
  mobileStaticBlockStack: {
    flexDirection: 'column',
    gap: Styles.Spacing.m2,
    paddingTop: Styles.Spacing.m3,
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingBottom: Styles.Spacing.m3,
    width: Platform.OS === 'web' ? '50%' : '100%',
    marginRight: Platform.OS === 'web' ? Styles.Spacing.m2 : Styles.Spacing.m0,
  },
  scrollView: {
    paddingBottom: Styles.Spacing.m2,
    flexGrow: 1,
    paddingRight: Styles.Spacing.m3 + Styles.Spacing.m1,
  },
  marginBottom: {marginBottom: Styles.Spacing.m1 + 2},
  backToRewardsBtn: {
    alignSelf: 'center',
    marginTop: Platform.OS === 'web' ? Styles.Spacing.m3 : Styles.Spacing.m0,
  },
});

export default RewardDetails;
